import React from "react";
import { Breadcrumb } from "bootstrap-micro";

import { connect } from "react-redux";
import { matchPath } from "react-router";
import { MULTILOOP_MODULE_NAMES } from "../const.js";
import { selectRelayById } from "../store/relaysSlice.js";
import { selectSiteName } from "../store/sitesSlice.js";
import { selectPanel, selectPanelModule, selectPanelModuleDevice, selectPanelZoneName } from "../store/panelsSlice.js";

const SiteName = connect((state, ownProps) => ({ label: selectSiteName(state, ownProps.hwaddr) }))((props) => <span>{props.label}</span>);
const ZoneName = connect((state, ownProps) => ({ label: selectPanelZoneName(ownProps.networkId, ownProps.hwaddr, ownProps.zoneId)(state) }))((props) => <span>{props.label}</span>);
// const LocalName = connect((state, ownProps) => ({ label: (getLocalDevice(ownProps.id) || {}).name }))((props) => <span>{props.label || `Local device (${props.id})`}</span>);
// const LoopName = connect((state, ownProps) => ({ label: (getLoopDevice(ownProps.id) || {}).name }))((props) => <span>{props.label || `Loop device (${props.id})`}</span>);

const RelayName = connect( (state, props) => ({ label: (selectRelayById(state, props.id)||{ name: props.id }).name  }) )( ({ label }) => <span>{label}</span>)

const PanelName = connect( (state, props ) => {
    const panel = selectPanel(props.hwaddr, props.networkId)(state);
    return { label: panel ? panel.strName : `Panel ${props.networkId}` }
})(({ label }) => <span>{label}</span>)

const ModuleName = connect( 
    (state, { hwaddr, networkId, portId }) => { 
        const mod = selectPanelModule(hwaddr, networkId, portId)(state);
        if(mod){
            return {
                lblPortId: mod.port_id,
                lblPortType: MULTILOOP_MODULE_NAMES[mod.port_type]
            };
        }
        return {
            lblPortId: "?",
            lblPortType: "?"
        };
    }
)( 
    ({ lblPortId, lblPortType }) => {
        return (<span>{lblPortId} - {lblPortType}</span>) 
    }
);

const ModuleDeviceName = connect( 
    (state, { networkId, hwaddr, portId, deviceId }) => { 
        const device = selectPanelModuleDevice(hwaddr, networkId, portId, deviceId)(state);
        if(device){
            return { label: device.name };
        }
        else{
            return { label: "?" };
        }
    }
)( 
    ({ label }) => (<span>{label}</span>) 
);

//Helper method for crumbs
let r = (pattern, name, routes = [], readOnly = false, subtitle = false) => ({ pattern, name, routes, readOnly, subtitle })
//Map crumbs as a tree of routes
const breadcrumbRoutes = [
    r("/help", "Help"),
    r("/privacy", "Privacy Policy"),
    r("/account", "My Account", [], false, true),
    r("/", "Site Manager", [
        r("relay", "Relay", [
            r("/add", "Add Relay", [], false, true),
            r("/:id([0-9]+)", p => <RelayName id={p.id} />, [], false, true),
        ], true),
        r("/site/add", "Add site"),
        r("/site/reauth", "Update key", [], true, true),
        r("/site/:hwaddr([0-9a-f]{12})", p => <SiteName hwaddr={p.hwaddr} />, [
            r("/panel/:networkId([0-9]{1,2})", p => <PanelName networkId={p.networkId} hwaddr={p.hwaddr} />, [
                r("/status", "Status"),
                r("/events", "Events"),
                r("/notifications", "Notifications"),
                // TODO: Undisable slices once bug fixed
                // r("/slices", "Day/Night editor"),
    
                r("/modules", "Modules", [
                    r("/:portId([0-9]+)", p => <ModuleName networkId={p.networkId} hwaddr={p.hwaddr} portId={p.portId} />, [
                        r("/device/:deviceId([0-9]+)", p => <ModuleDeviceName networkId={p.networkId} hwaddr={p.hwaddr} portId={p.portId} deviceId={p.deviceId} />, [], false, true)
                    ], false, true)
                ]),
                
                r("/zone", "Zones", [r("/:zoneId([0-9]{1,})", p => <ZoneName networkId={p.networkId} hwaddr={p.hwaddr} zoneId={p.zoneId} />, [], false, true)], true),
                // r("/devices", "Devices", [
                //     r("/local", "Local devices", [r("/:id([0-9]{1,})", p => <LocalName id={p.id} />, [], false, true)], true),
                //     r("/loop", "loop devices", [r("/:id([0-9]{1,})", p => <LoopName id={p.id} />, [], false, true)], true),
                // ]),
                r("/about", "About"),
            ])
        ], false, true),
    ], false, true)
];


//Combines to patterns removing double slashes
const mergePatterns = (a, b) => a[a.length - 1] === "/" && b[0] === "/" ? `${a.slice(0, a.length - 1)}${b}` : `${a}${b}`
//Iterate over a list of routes, recursing down to find the breadcrumbs for a route.
function parseBreadcrumbs(location, routes, prefix = "") {
    for (var x in routes) {
        let r = routes[x];
        let p = mergePatterns(prefix, r.pattern);
        let match = matchPath(location, {
            path: p,
            exact: r.exact
        })
        if (match) {
            return [{ route: r, match: match }].concat(parseBreadcrumbs(location, r.routes || [], p))
        }
    }
    return [];
}

export function AppHeader(props) {
    let crumbs = parseBreadcrumbs(props.location.pathname, breadcrumbRoutes);
    return <div id="app-header" className="container">
        <Breadcrumb>
            <Breadcrumb.Item active={true} >Home</Breadcrumb.Item>
            {crumbs.map((e, idx, arr) => {
                return <Breadcrumb.Item
                    key={idx}
                    href={"#" + e.match.url}
                    active={e.route.readOnly || (idx == arr.length - 1)}
                >
                    {typeof e.route.name == "string" ? e.route.name : e.route.name(e.match.params)}
                </Breadcrumb.Item>
            })}
        </Breadcrumb>
        <h2 id="subtitle">{(() => {
            let e = crumbs.filter(e => e.route.subtitle);
            e = e.length == 0 ? { route: { name: "" } } : e[e.length - 1];
            return typeof e.route.name == "string" ? e.route.name : e.route.name(e.match.params);
        })()}</h2>
    </div>
}